import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a Drivers Hours Warning icon
 * (RDT value that indicates infringements, used in the Drivers module).
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DriversHoursWarningIcon width={12} />
 */
const DriversHoursWarningIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M27.25,33a3.38,3.38,0,1,1-3.38-3.38,3.35,3.35,0,0,1,3.38,3.3V33m0-18.57h0a3.38,
            3.38,0,0,0-6.76,0,1.58,1.58,0,0,0,.11.71l1,10.33a2.22,2.22,0,0,0,4.44,0ZM23.87,
            7.22a16.5,16.5,0,1,1-16.5,16.5,16.52,16.52,0,0,1,16.5-16.5m0-5a21.5,21.5,0,1,0,
            21.5,21.5A21.49,21.49,0,0,0,23.87,2.22Z`}
        />
    </SvgIcon>
)

DriversHoursWarningIcon.defaultProps = defaultProps

export { DriversHoursWarningIcon }
